import React, { useEffect } from "react";
import "./vendors.scss";
import Jumbotron from "../../components/jumbotron/Jumbotron";
import { useWindowSize } from "../../hooks/useWindowSize";
import { MOBILE_WIDTH } from "../../constants/screenSizes";
import Divider from "../../components/Divider/Divider";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

export default function Vendors() {
  const windowSize = useWindowSize();
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <div>
      <Jumbotron
        title="Braids by Conn"
        content="Braids by Conn is a trusted event vendor specializing in stylish braids for birthday parties, pow wows, and special gatherings. Book now to bring beauty and tradition right to your event — wherever it's happening"
      />
      <div className="vendor-main">
        <div className="vendor-main-container">
          <div>
            <p className="home-secondary-text">
              Braids by Conn offers professional braiding services for birthday parties, pow wows, and special events.
              Celebrate with style and tradition — call to inquire about availability and pricing.
            </p>
            <br />
            <div className="vendor-main-contact-group">
              <p className="vendor-title">
                {" "}
                <FontAwesomeIcon className="vendor-icon" icon={faPhone} /> Phone:{" "}
                <a className="vendor-content" href="tel:519-496-1246">
                  +1 519-496-1246
                </a>
              </p>
              <p className="vendor-title">
                <FontAwesomeIcon className="vendor-icon" icon={faEnvelope} /> Email:{" "}
                <a className="vendor-content" href="mailto:comfortcutzmobilesalon@gmail.com">
                  comfortcutzmobilesalon@gmail.com
                </a>
              </p>
              <p className="vendor-title">
                <FontAwesomeIcon className="vendor-icon" icon={faInstagram} /> Instagram:{" "}
                <a
                  className="vendor-content"
                  href="https://www.instagram.com/braidsbyconn"
                  target="_blank"
                  rel="noreferrer"
                >
                  braidsbyconn
                </a>
              </p>
            </div>
          </div>

          {windowSize.width > MOBILE_WIDTH && (
            <Divider position="vertical" colour="secondary" thickness={2} height={200} />
          )}

          <LazyLoadImage
            src={"images/braids_by_conn.webp"}
            width="auto"
            className="hair-img"
            alt="Braids by Conn Logo"
            style={{ borderRadius: "8px" }}
          />
        </div>
      </div>
    </div>
  );
}
